

import apiCall from "../apiService";

/**
 * Fetches the hot items of the month using the centralized API call utility.
 *
 * @returns {Promise<Object>} - The response data from the server.
 * @throws Will throw an error if the request fails.
 *
 * Mishra
 */
const fetchHotItems = async () => {
  return await apiCall("/products/hotitems", {
    method: "GET",
  });
};

export default fetchHotItems;
